import Swiper from 'swiper';
import { Navigation, A11y } from 'swiper/modules';
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/a11y'
import domReady from '@src/js/utils/domReady.js'

function eventsFeedSwiper() {
  const swiperEl = document.querySelector('.content-block--events-feed__carousel')
  if (!swiperEl) return

  new Swiper(swiperEl, {
    modules: [Navigation, A11y],
    slidesPerView: 1.3,
    slidesPerGroup: 1,
    spaceBetween: 20,
    speed: 750,
    breakpoints: {
      768: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 40
      },
    },
    a11y: {
      enabled: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    keyboard: {
      enabled: true,
    }
  })
}

domReady(function () {
  eventsFeedSwiper()
})
